import { useCallback } from "react";
import getPreferredLocale from "../../util/getPreferredLocale";

const useBrowserLocale = (): string => {
    const locale = useCallback((navigator: Navigator) => {
        return getPreferredLocale(navigator);
    }, []);
    return locale(navigator);
}

export default useBrowserLocale;